import { DeleteStrongProfile, DeleteWeakProfile } from 'routes/Privacy';
import ACard from './ACard';
import ACardTransfer from './ACard/ACardTransfer';
import {
  EID,
  EIDAdd,
  EmailDelete,
  EmailDetail,
  EmailForm,
  PasswordUpdate,
  PhoneAdd,
  PhoneDetail,
  PhoneEdit,
} from './AccessKeys';
import EmailUpdate from './AccessKeys/EmailUpdate';
import EmailVerify from './AccessKeys/EmailVerify';
import EmailVerifyError from './AccessKeys/EmailVerify/EmailVerifyError';
import EmailVerifySuccess from './AccessKeys/EmailVerify/EmailVerifySuccess';
import Dashboard from './Dashboard';
import DataOverview from './DataOverview';
import ECounter from './ECounter';
import Newsletters from './Newsletters';
import NotFound from './NotFound';
import Preferences from './Preferences';
import { RouteObject } from './router';

const routes: RouteObject[] = [
  {
    component: Dashboard,
    breadcrumb: 'dashboard.title',
    exact: true,
    path: '/',
  },
  {
    component: DataOverview,
    breadcrumb: 'data.breadcrumb.title',
    exact: true,
    path: '/gegevens',
    routes: [
      {
        component: EmailDetail,
        exact: true,
        path: '/aanmeldsleutels/e-mail',
        breadcrumb: 'accessKeys.email.breadcrumb.title',
        routes: [
          {
            component: EmailForm,
            exact: true,
            path: '/toevoegen',
            routes: [
              {
                component: EmailVerifySuccess,
                exact: true,
                unprotected: true,
                path: '/gekoppeld',
              },
              {
                component: EmailVerifyError,
                exact: true,
                unprotected: true,
                path: '/ongeldig',
              },
            ],
          },
          {
            component: EmailUpdate,
            exact: true,
            path: '/wijzigen',
            routes: [
              {
                component: EmailVerifySuccess,
                exact: true,
                unprotected: true,
                path: '/gekoppeld',
              },
              {
                component: EmailVerifyError,
                exact: true,
                unprotected: true,
                path: '/ongeldig',
              },
            ],
          },
          {
            component: EmailVerify,
            exact: true,
            unprotected: true,
            path: '/callback',
          },
          {
            component: EmailDelete,
            exact: true,
            path: '/verwijderen',
          },
        ],
      },
      {
        component: PasswordUpdate,
        exact: true,
        path: '/aanmeldsleutels/wachtwoord/wijzigen',
      },
      {
        component: PhoneDetail,
        exact: true,
        path: '/aanmeldsleutels/telefoon',
        breadcrumb: 'accessKeys.phone.breadcrumb.title',
        routes: [
          {
            component: PhoneAdd,
            exact: true,
            path: '/toevoegen',
          },
          {
            component: PhoneEdit,
            exact: true,
            path: '/wijzigen',
          },
        ],
      },
      {
        component: EID,
        exact: true,
        path: '/aanmeldsleutels/rijksregisternummer',
        routes: [
          {
            component: EIDAdd,
            exact: true,
            path: '/toevoegen',
          },
        ],
      },
      {
        component: DeleteStrongProfile,
        exact: true,
        path: '/privacy/sterk-profiel/verwijderen',
        breadcrumb: 'privacy.strongProfile.breadcrumb.title',
      },
      {
        component: DeleteWeakProfile,
        exact: true,
        path: '/privacy/zwak-profiel/verwijderen',
        breadcrumb: 'privacy.weakProfile.breadcrumb.title',
      },
    ],
  },
  {
    component: ECounter,
    breadcrumb: 'ecounter.title',
    path: '/mijn-eloket',
    exact: true,
  },
  {
    component: ACard,
    breadcrumb: 'acard.title',
    path: '/a-kaart',
    exact: true,
    routes: [
      {
        component: ACardTransfer,
        breadcrumb: 'acard.transfer.title',
        exact: true,
        path: '/geef-handjes-cadeau',
      },
    ],
  },
  {
    component: Preferences,
    breadcrumb: 'preferences.title',
    path: '/voorkeuren',
    exact: true,
  },
  {
    component: Newsletters,
    breadcrumb: 'newsletters.breadcrumb.title',
    path: '/nieuwsbrieven',
    exact: true,
  },
  {
    component: NotFound,
    exact: false,
  },
];

export type Routes = (typeof routes)[number]['path'];

export default routes;
